export default __webpack_public_path__ + "static/media/chat-notif.5b9ecb19.wav";